//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'GuideDetail',

  data() {
    return {
      CDN: process.env.CDN,
    };
  },

  computed: {
    ...mapState(['guideDetail']),
  },

  async validate({ store, params }) {
    const guideDetail = await store.dispatch('getGuideDetail', params.guideId);
    return !!guideDetail;
  },
};
